/* eslint-disable max-len */
/* eslint-disable react/jsx-props-no-spreading */
import React, {useRef} from 'react';

import {SvgIconProps} from '@mui/material';

import {generateKey} from '@utils/id';

import {Icon} from './Icon';

const USDCurrency: React.FC<SvgIconProps> = ({...props}) => {
    const seed = useRef(generateKey());
    return (
        <Icon {...props}>
            <defs>
                <linearGradient x1='50%' y1='0%' x2='50%' y2='100%' id={`linearGradient-usd-1-${seed.current}`}>
                    <stop stopColor='#FFFFFF' offset='0%'/>
                    <stop stopColor='#F0F0F0' offset='100%'/>
                </linearGradient>
                <linearGradient x1='50%' y1='0%' x2='50%' y2='100%' id={`linearGradient-usd-2-${seed.current}`}>
                    <stop stopColor='#D02F44' offset='0%'/>
                    <stop stopColor='#B12537' offset='100%'/>
                </linearGradient>
                <linearGradient x1='50%' y1='0%' x2='50%' y2='100%' id={`linearGradient-usd-3-${seed.current}`}>
                    <stop stopColor='#46467F' offset='0%'/>
                    <stop stopColor='#3C3C6D' offset='100%'/>
                </linearGradient>
            </defs>
            <g id='Symbols' stroke='none' strokeWidth='1' fill='none' fillRule='evenodd'>
                <g id='US'>
                    <rect
                        id='FlagBackground'
                        fill={`url(#linearGradient-usd-1-${seed.current})`}
                        x='0'
                        y='0'
                        width='24'
                        height='25'
                    />
                    <path
                        d='M0,0 L21,0 L21,1 L0,1 L0,0 Z M0,2 L21,2 L21,3 L0,3 L0,2 Z M0,4 L21,4 L21,5 L0,5 L0,4 Z M0,6 L21,6 L21,7 L0,7 L0,6 Z M0,8 L21,8 L21,9 L0,9 L0,8 Z M0,10 L21,10 L21,11 L0,11 L0,10 Z M0,12 L21,12 L21,13 L0,13 L0,12 Z M0,14 L21,14 L21,15 L0,15 L0,14 Z'
                        id='Rectangle-511'
                        fill={`url(#linearGradient-usd-2-${seed.current})`}
                    />
                    <rect
                        id='Rectangle-511'
                        fill={`url(#linearGradient-usd-3-${seed.current})`}
                        x='0'
                        y='0'
                        width='9'
                        height='7'
                    />
                    <path
                        d='M1.5,2 C1.22385763,2 1,1.77614237 1,1.5 C1,1.22385763 1.22385763,1 1.5,1 C1.77614237,1 2,1.22385763 2,1.5 C2,1.77614237 1.77614237,2 1.5,2 Z M3.5,2 C3.22385763,2 3,1.77614237 3,1.5 C3,1.22385763 3.22385763,1 3.5,1 C3.77614237,1 4,1.22385763 4,1.5 C4,1.77614237 3.77614237,2 3.5,2 Z M5.5,2 C5.22385763,2 5,1.77614237 5,1.5 C5,1.22385763 5.22385763,1 5.5,1 C5.77614237,1 6,1.22385763 6,1.5 C6,1.77614237 5.77614237,2 5.5,2 Z M7.5,2 C7.22385763,2 7,1.77614237 7,1.5 C7,1.22385763 7.22385763,1 7.5,1 C7.77614237,1 8,1.22385763 8,1.5 C8,1.77614237 7.77614237,2 7.5,2 Z M2.5,3 C2.22385763,3 2,2.77614237 2,2.5 C2,2.22385763 2.22385763,2 2.5,2 C2.77614237,2 3,2.22385763 3,2.5 C3,2.77614237 2.77614237,3 2.5,3 Z M4.5,3 C4.22385763,3 4,2.77614237 4,2.5 C4,2.22385763 4.22385763,2 4.5,2 C4.77614237,2 5,2.22385763 5,2.5 C5,2.77614237 4.77614237,3 4.5,3 Z M6.5,3 C6.22385763,3 6,2.77614237 6,2.5 C6,2.22385763 6.22385763,2 6.5,2 C6.77614237,2 7,2.22385763 7,2.5 C7,2.77614237 6.77614237,3 6.5,3 Z M7.5,4 C7.22385763,4 7,3.77614237 7,3.5 C7,3.22385763 7.22385763,3 7.5,3 C7.77614237,3 8,3.22385763 8,3.5 C8,3.77614237 7.77614237,4 7.5,4 Z M5.5,4 C5.22385763,4 5,3.77614237 5,3.5 C5,3.22385763 5.22385763,3 5.5,3 C5.77614237,3 6,3.22385763 6,3.5 C6,3.77614237 5.77614237,4 5.5,4 Z M3.5,4 C3.22385763,4 3,3.77614237 3,3.5 C3,3.22385763 3.22385763,3 3.5,3 C3.77614237,3 4,3.22385763 4,3.5 C4,3.77614237 3.77614237,4 3.5,4 Z M1.5,4 C1.22385763,4 1,3.77614237 1,3.5 C1,3.22385763 1.22385763,3 1.5,3 C1.77614237,3 2,3.22385763 2,3.5 C2,3.77614237 1.77614237,4 1.5,4 Z M2.5,5 C2.22385763,5 2,4.77614237 2,4.5 C2,4.22385763 2.22385763,4 2.5,4 C2.77614237,4 3,4.22385763 3,4.5 C3,4.77614237 2.77614237,5 2.5,5 Z M4.5,5 C4.22385763,5 4,4.77614237 4,4.5 C4,4.22385763 4.22385763,4 4.5,4 C4.77614237,4 5,4.22385763 5,4.5 C5,4.77614237 4.77614237,5 4.5,5 Z M6.5,5 C6.22385763,5 6,4.77614237 6,4.5 C6,4.22385763 6.22385763,4 6.5,4 C6.77614237,4 7,4.22385763 7,4.5 C7,4.77614237 6.77614237,5 6.5,5 Z M7.5,6 C7.22385763,6 7,5.77614237 7,5.5 C7,5.22385763 7.22385763,5 7.5,5 C7.77614237,5 8,5.22385763 8,5.5 C8,5.77614237 7.77614237,6 7.5,6 Z M5.5,6 C5.22385763,6 5,5.77614237 5,5.5 C5,5.22385763 5.22385763,5 5.5,5 C5.77614237,5 6,5.22385763 6,5.5 C6,5.77614237 5.77614237,6 5.5,6 Z M3.5,6 C3.22385763,6 3,5.77614237 3,5.5 C3,5.22385763 3.22385763,5 3.5,5 C3.77614237,5 4,5.22385763 4,5.5 C4,5.77614237 3.77614237,6 3.5,6 Z M1.5,6 C1.22385763,6 1,5.77614237 1,5.5 C1,5.22385763 1.22385763,5 1.5,5 C1.77614237,5 2,5.22385763 2,5.5 C2,5.77614237 1.77614237,6 1.5,6 Z'
                        id='Oval-43'
                        fill={`url(#linearGradient-usd-1-${seed.current})`}
                    />
                </g>
            </g>
        </Icon>
    );
};

export {USDCurrency};
